import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SearchModel, SearchResultModel } from 'src/common';
import { environment } from 'src/environments/environment';
import { OrganizationalUnitModel } from './organizational-unit.model';

const localApiUrl = `${environment.apiUrl}/OrganizationalUnit`;

@Injectable()
export class OrganizationalUnitService {

    constructor(private http: HttpClient) { }

    search(search: SearchModel): Promise<SearchResultModel<OrganizationalUnitModel>> {
        return this.http.post<SearchResultModel<OrganizationalUnitModel>>(`${localApiUrl}/Search`, search).toPromise();
    }

    getAll(): Promise<OrganizationalUnitModel[]> {
        return this.http.get<OrganizationalUnitModel[]>(`${localApiUrl}/All`).toPromise();
    }

}
